import { usePreferencesState } from '../../../state/PreferencesStateContext';

/**
 * Editor Preferences hook.
 *
 * A thin selector over the single app-wide PreferencesStateProvider
 * (src/state/PreferencesStateContext.jsx) -- every caller shares one state, so
 * a change made anywhere re-renders everyone. Kept as its own module so the
 * existing import path and `{ preferences, updatePreference, resetPreferences,
 * isLoaded }` shape don't change for callers (or for tests that mock this path).
 */
export const useEditorPreferences = () => usePreferencesState();

export default useEditorPreferences;
